import { useQuery } from '@tanstack/react-query';
import type { UseQueryOptions } from '@tanstack/react-query';
import { handleResponseThrowError } from '@/_utils/services';
import type { Delivery } from '../types';
import { GET_DELIVERY_DETAIL } from '../constants';
import { apiClient } from '@/_config/lib/axios/api-client';

interface GetDeliveryDetailParams {
  deliveryId: string;
}

const getDeliveryDetail = ({ deliveryId }: GetDeliveryDetailParams) => {
  return apiClient
    .get<Delivery>(`/entregas/${deliveryId}/detail-delivery`)
    .then(response => response.data)
    .catch(handleResponseThrowError());
};

type GetDeliveryDetailData = Awaited<ReturnType<typeof getDeliveryDetail>>;

export const useGetDeliveryDetail = (
  params: GetDeliveryDetailParams,
  options?: UseQueryOptions<
    GetDeliveryDetailData,
    unknown,
    GetDeliveryDetailData,
    (string | GetDeliveryDetailParams)[]
  >,
) => {
  return useQuery({
    queryKey: [GET_DELIVERY_DETAIL, params],
    queryFn: () => getDeliveryDetail(params),
    ...options,
  });
};
